import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Icon } from '..';
import styles from './index.module.less';
export const VideoPlayer = ({ className, src, ...rest }) => {
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const togglePlayStatus = useCallback(() => {
        const videoEle = videoRef.current;
        if (!videoEle)
            return;
        if (videoEle.paused || videoEle.ended) {
            videoEle.play();
        }
        else {
            videoEle.pause();
        }
    }, [playing]);
    useEffect(() => {
        const videoEle = videoRef.current;
        if (!videoEle)
            return;
        const onPlaying = () => {
            setPlaying(true);
        };
        const onEndedOrPause = () => {
            setPlaying(false);
        };
        videoEle.addEventListener('playing', onPlaying);
        videoEle.addEventListener('ended', onEndedOrPause);
        videoEle.addEventListener('pause', onEndedOrPause);
        return () => {
            videoEle.removeEventListener('playing', onPlaying);
            videoEle.removeEventListener('ended', onEndedOrPause);
            videoEle.removeEventListener('pause', onEndedOrPause);
        };
    }, []);
    return (_jsxs("div", { className: classnames(className, styles.player), children: [_jsx("video", { src: src, height: "100%", width: "100%", ref: videoRef, controls: playing, ...rest }), _jsx("div", { className: styles.playPause, role: "button", onClick: togglePlayStatus, children: _jsx(Icon, { type: playing ? 'pause' : 'play' }) })] }));
};
